import { createContext } from 'react'

export interface IPopupContext {
  register: (closeFunction: () => void) => void
  unregister: (closeFunction: () => void) => void
}

export const PopupContext = createContext({} as IPopupContext)
